// extracted by mini-css-extract-plugin
export default {"root":"NewTeacher_root__-4yxk","form":"NewTeacher_form__S3ykY","card":"NewTeacher_card__OHK2+","footer":"NewTeacher_footer__SwDZq"};